// Port of api/fuel/app/classes/controller/api/monty/app/about.php
import DB from 'offline/db'

function setting(name) {
	var rows = DB.query('SELECT setting_value FROM generic_settings WHERE setting_name = ? LIMIT 1', [name])
	return rows.length ? rows[0].setting_value : ''
}

export default function() {
	return Promise.resolve({
		title: 'About',
		description: '',
		body: setting('page_about')
	})
}
